import { ReactNode } from "react";
import DescriptionIcon from "@mui/icons-material/Description";
import WalletIcon from "@mui/icons-material/AccountBalanceWallet";
import { OrderStatusBadgeEnum } from "@/enums/orderStatusBadge";
import HouseIcon from "@mui/icons-material/House";
import { InforStatusLabelEnum } from "@/enums/InforStatusLabelEnum";
import AirportShuttleIcon from "@mui/icons-material/AirportShuttle";
import DepartureBoardIcon from "@mui/icons-material/DepartureBoard";
import { LocalShippingOutlined } from "@mui/icons-material";

class StyleHelper {
  static getOrderStatusBadgeColors(status: string | null): {
    background: string;
    color: string;
  } {
    if (status && OrderStatusBadgeColorMap[status as OrderStatusBadgeEnum]) {
      return OrderStatusBadgeColorMap[status as OrderStatusBadgeEnum];
    }

    return { background: "#EEE", color: "#999" };
  }

  static getInforStatusLabel(status: string | null) {
    if (!status) {
      return {
        icon: null,
        label: "",
        color: "#CCC",
      };
    }

    return (
      InforStatusLabelMap[status] || {
        icon: null,
        label: "",
        color: "#CCC",
      }
    );
  }
}

const OrderStatusBadgeColorMap: Record<
  OrderStatusBadgeEnum,
  { background: string; color: string }
> = {
  [OrderStatusBadgeEnum.IN_PROGRESS]: {
    background: "#D9F0FF",
    color: "#62B5E5",
  },
  [OrderStatusBadgeEnum.COMPLETE]: {
    background: "#E3FFBD",
    color: "#64A70B",
  },
  [OrderStatusBadgeEnum.QUOTED]: {
    background: "#FFF4E5",
    color: "#FFA500",
  },
};

const InforStatusLabelMap: Record<
  string,
  { icon: ReactNode; label: string; color: string }
> = {
  [InforStatusLabelEnum.INVOICED]: {
    icon: <DescriptionIcon sx={{ color: "#F3A536", fontSize: "16px" }} />,
    label: InforStatusLabelEnum.INVOICED,
    color: "#F3A536",
  },
  [InforStatusLabelEnum.PAID_IN_FULL]: {
    icon: <WalletIcon sx={{ color: "#51A2FF", fontSize: "16px" }} />,
    label: InforStatusLabelEnum.PAID_IN_FULL,
    color: "#51A2FF",
  },
  [InforStatusLabelEnum.NEEDS_DELIVERY_SCHEDULED]: {
    icon: <HouseIcon sx={{ color: "#F3A536", fontSize: "16px" }} />,
    label: InforStatusLabelEnum.NEEDS_DELIVERY_SCHEDULED,
    color: "#F3A536",
  },
  [InforStatusLabelEnum.READY_FOR_PICKUP]: {
    icon: <AirportShuttleIcon sx={{ color: "#64a70b", fontSize: "16px" }} />,
    label: InforStatusLabelEnum.READY_FOR_PICKUP,
    color: "#64a70b",
  },
  [InforStatusLabelEnum.DELIVERY_SCHEDULED]: {
    icon: <DepartureBoardIcon sx={{ color: "#64a70b", fontSize: "16px" }} />,
    label: InforStatusLabelEnum.DELIVERY_SCHEDULED,
    color: "#64a70b",
  },
  [InforStatusLabelEnum.RETURN_IN_PROGRESS]: {
    icon: <LocalShippingOutlined sx={{ color: "#62b5e5", fontSize: "16px" }} />,
    label: InforStatusLabelEnum.RETURN_IN_PROGRESS,
    color: "#62b5e5",
  },
};

export default StyleHelper;
